module.exports = __webpack_public_path__ + "img/Proliferation-PDAC_GSE205354.fac102c5.png";